import { ref } from 'vue';

import { Entry } from '@/types';

export function onClickPronounce(url: string) {
	const audio = new Audio(url);
	audio.addEventListener('canplaythrough', () => audio.play(), { once: true });
}

export function isHumanVerified(entry: Entry): boolean {
	return new Date(entry.verifiedAt) > new Date(2000, 1, 1);
}

export function formatDateTimeHuman(date: Date): string {
	const pad = (n: number): string => (n < 10 ? '0' + n : n.toString());

	const day = pad(date.getDate());
	const month = pad(date.getMonth() + 1); // Months are zero-based
	const year = String(date.getFullYear()).slice(2); // Get last two digits of year
	const hours = pad(date.getHours());
	const minutes = pad(date.getMinutes());
	const seconds = pad(date.getSeconds());

	return `${day}-${month}-${year}, ${hours}:${minutes}:${seconds}`;
}

export function capitalize(word: string) {
	return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export function shortenText(text: string, max: number, dots?: boolean) {
	if (text.length >= max) {
		return text.slice(0, max - 3) + (dots ? '...' : '');
	}

	return text;
}

export const shuffle = <T>(array: T[]) => {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
};

const xl = 1280;
const lg = 1030;
const sm = 640;
const focusModeLimit = 740;

export const isXl = ref(window.innerWidth >= xl);
export const isLg = ref(window.innerWidth >= lg);
export const isMd = ref(window.innerWidth >= sm && window.innerWidth < lg);
export const isMobile = ref(window.innerWidth < sm);
export const belowFocusLimit = ref(window.innerWidth < focusModeLimit);

export function updateSize(): void {
	isXl.value = window.innerWidth >= xl;
	isLg.value = window.innerWidth >= lg;
	isMd.value = window.innerWidth >= sm && window.innerWidth < lg;
	isMobile.value = window.innerWidth < sm;
	belowFocusLimit.value = window.innerWidth < focusModeLimit;
}

window.addEventListener('resize', updateSize);
